exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-fund-l-js": () => import("./../../../src/pages/fund-l.js" /* webpackChunkName: "component---src-pages-fund-l-js" */),
  "component---src-pages-fund-s-js": () => import("./../../../src/pages/fund-s.js" /* webpackChunkName: "component---src-pages-fund-s-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

